export default {
	0: state => ({
		...state,
		reducerUser: {
			...state.reducerUser,
			userEmail: null,
		},
	}),
};
